import { Input } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import styled from "styled-components";

export const BlackSpan = styled.span`
    color: ${globalThis.config.colors.black};
`;

export const MenuTab = styled(Tab)({
    "&.MuiTab-root": {
        textTransform: "none",
        minWidth: "5rem",
        fontSize: globalThis.config.fonts.sizes.xsmall,
        fontFamily: globalThis.config.fonts.families.light,
        width: "7.031rem",
        borderRadius: globalThis.config.sizes.borderRadius,
        borderBottom: globalThis.config.border.smallGray7,
    },
});

export const SearchInput = styled(Input)({
    "&.MuiInputBase-root": {
        fontSize: globalThis.config.fonts.sizes.small,
        width: "100%",
        height: "3rem",
        paddingLeft: "1rem",
    },
});

export const LoaderWrapper = styled.div`
    margin: 1rem 5.6rem;
`;

export const ArrowWrapper = styled.div`
    > svg {
        display: none;
    }
    width: 1rem;
    position: absolute;
    right: 1rem;
`;
